import { HeadlessFormProvider } from '@delmonicos/shared-design-system-react/src/contexts/headless-form.provider';
import { SubmitHandlerWithDirtyFields } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { GetEmspUsersPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/emsp-users/get-emsp-users-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { useFilterSearchEmspBoEmspUserListContext } from '../../emsp-bo-emsp-user.context';
import { EmspBoEmspUserListFilterSearchFormStep1Controller } from '../emsp-bo-emsp-user-list-filter-search-form-step-1/emsp-bo-emsp-user-list-filter-search-form-step-1.controller';

export interface EmspBoEmspUserListFilterSearchFormControllerProps {
  onError: SubmitErrorHandler<GetEmspUsersPaginatedModel>;
  onSubmit: SubmitHandlerWithDirtyFields<GetEmspUsersPaginatedModel>;
  onCancel: () => void;
}

export const EmspBoEmspUserListFilterSearchFormController = (
  props: EmspBoEmspUserListFilterSearchFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel } = props;
  const data = useFilterSearchEmspBoEmspUserListContext();

  return (
    <HeadlessFormProvider<GetEmspUsersPaginatedModel>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      item={{
        fields: ['textToSearch'],
        component: <EmspBoEmspUserListFilterSearchFormStep1Controller />,
      }}
    />
  );
};
